import { render, staticRenderFns } from "./vBienvenido.vue?vue&type=template&id=7372e96a&scoped=true&"
import script from "./vBienvenido.vue?vue&type=script&lang=js&"
export * from "./vBienvenido.vue?vue&type=script&lang=js&"
import style0 from "./vBienvenido.vue?vue&type=style&index=0&id=7372e96a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7372e96a",
  null
  
)

export default component.exports